import { render, staticRenderFns } from "./construction.vue?vue&type=template&id=3c149061"
import script from "./construction.vue?vue&type=script&lang=js"
export * from "./construction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c149061')) {
      api.createRecord('3c149061', component.options)
    } else {
      api.reload('3c149061', component.options)
    }
    module.hot.accept("./construction.vue?vue&type=template&id=3c149061", function () {
      api.rerender('3c149061', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/construction.vue"
export default component.exports